import React from 'react';
import { Modal, Col, Row, Descriptions, Spin, Avatar, Tabs, Tooltip } from 'antd';
import moment from 'moment-jalaali';
import { usePersistedStore } from '../../store/persisted-store';
import { useGeneralStore } from '../../store/slices/createGeneralSlice';

moment.loadPersian();
const { TabPane } = Tabs;

export default function ShowBusiness() {
    const { business: businessState } = usePersistedStore();
    const general = useGeneralStore();
    const visible = general.view.businessShowModal;
    const loading = businessState.businesses.loading;
    const business = businessState.businesses.byToken;
    const phones = business?.phone?.split?.(',') || [];
    const hasMultiplePhones = phones.length > 1;
    const businessByToken = businessState?.businesses?.byToken;
    const primaryColor = businessByToken?.styles?.primaryColor

    return (
        <Modal
            style={{
                top: 80
            }}
            title="اطلاعات شریک تجاری"
            className="custom-table"
            open={visible}
            footer={false}
            width="90%"
            onCancel={() => general.ToggleBusinessShowModal()}>
            <Spin spinning={loading}>
                <Row gutter={16}>
                    <Col lg={18} xs={12} md={8}>
                        <h3 className="business-info-name">{business?.name}</h3>
                        <span className="business-info-date">
                            {moment(business?.createdAt).format('jYYYY/jM/jD')}
                        </span>
                        <a href={business?.domain}
                            className="business-info-domain"><span>{business?.domain}</span></a>
                        <h5 className="business-info-token"><span>{business?.token}</span></h5>
                    </Col>
                    <Col lg={6} xs={12} md={4} >
                        <div className="business-info-logo">
                            <Avatar src={business?.logo} shape="square" className="logo-img" />
                        </div>
                    </Col>
                </Row>=
                <Row gutter={16} >
                    <Col lg={24} xs={24} md={24}>
                        <div className='showBusiness-tab'>
                            <Tabs defaultActiveKey="0"  >
                                <TabPane tab="اطلاعات تماس" id="contactInfo" key="0"  >
                                    <Descriptions
                                        bordered
                                        size="small"
                                        column={1}>
                                        <Descriptions.Item className="business-info-tab" label="شماره تماس">
                                            {phones.map((phone, index) => (
                                                <React.Fragment key={phone}>
                                                    {hasMultiplePhones && index === 0 ? (
                                                        <Tooltip title="شماره تلفن اصلی">
                                                            <span
                                                                style={{
                                                                    color: primaryColor,
                                                                    cursor: "help",
                                                                }}
                                                            >
                                                                {phone}
                                                            </span>
                                                        </Tooltip>
                                                    ) : (
                                                        <span
                                                            style={{
                                                                color: "black",
                                                            }}
                                                        >
                                                            {phone}
                                                        </span>
                                                    )}

                                                    {index < phones.length - 1 && ", "}
                                                </React.Fragment>
                                            ))}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="پست الکترونیکی">{business?.email}</Descriptions.Item>
                                        <Descriptions.Item label="آدرس">{business?.address
                                            ? business.address
                                                .split(/\|\|\||\\n/)
                                                .map(a => a.trim())
                                                .filter(a => a) : ""}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="نمایش هوم رشته ها">
                                            {business?.showBranchHome ?
                                                'دارد' :
                                                'ندارد'}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="نمایش محتوای بیمه‌دات کام">
                                            {business?.showBimehContent ?
                                                'دارد' :
                                                'ندارد'}
                                        </Descriptions.Item>
                                    </Descriptions>
                                </TabPane>
                                <TabPane tab="تنظیمات" id="settings" key="1" >
                                    <Descriptions
                                        bordered
                                        size="small"
                                        column={1}>
                                        <Descriptions.Item className="business-info-tab" label=" از موتورهای جستجو درخواست کن تا محتوای سایت را بررسی کنند">
                                            {business?.follow ?
                                                'دارد' :
                                                'ندارد'}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="نمایش راهنمای خرید رشته‌ها">
                                            {business?.guide ?
                                                'دارد' :
                                                'ندارد'}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="صفحه اصلی">
                                            {business?.layout ?
                                                'دارد' :
                                                'ندارد'}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="اکسترنال لاگین ">
                                            {business?.login ?
                                                'دارد' :
                                                'ندارد'}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="فعال بودن ثبت نام">
                                            {business?.userRegistration ?
                                                'دارد' :
                                                'ندارد'}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="سیستم بازاریاب فعال است">
                                            {business?.marketerSystem ?
                                                'دارد' :
                                                'ندارد'}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="سیستم تیکت فعال است">
                                            {business?.hasTicketingService ?
                                                'دارد' :
                                                'ندارد'}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="باکس کد تخفیف در پلن لیست">
                                            {business?.showVoucherBoxInPlanList ?
                                                'دارد' :
                                                'ندارد'}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="باکس کد تخفیف در مرحله پرداخت">
                                            {business?.showVoucherBoxInPrePayment ?
                                                'دارد' :
                                                'ندارد'}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="فعال سازی PWA">
                                            {business?.PwaEnabled ?
                                                'دارد' :
                                                'ندارد'}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="ورود تنها با OTP">
                                            {business?.onlyOtpLogin ?
                                                'دارد' :
                                                'ندارد'}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="فعال بودن حالت دیباگ">
                                            {business?.debug ?
                                                'دارد' :
                                                'ندارد'}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="نمایش لینک صفحه ی یادآور بیمه در منو">
                                            {business?.allowUseReminders ?
                                                'دارد' :
                                                'ندارد'}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="روش دانلود">
                                            {business?.aElementDownloadType == 0 ?
                                                'عادی' :
                                                business?.aElementDownloadType == 1 ?
                                                    'تب جدید' :
                                                    business?.aElementDownloadType == 2 ? "JSON" : ""}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="نمایش کپی رایت در فوتر">
                                            {business?.copyright ?
                                                'دارد' :
                                                'ندارد'}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="فعال شدن نمایش کوکی">
                                            {business?.gdprCompliant ?
                                                'دارد' :
                                                'ندارد'}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="لینک بنر ">
                                            <a href={business?.bannersLink} target="_blank">
                                                <span>{business?.bannersLink}</span>
                                            </a>
                                        </Descriptions.Item>
                                        <Descriptions.Item label="tagManager-id">{business?.TagmanagerCode}</Descriptions.Item>
                                        <Descriptions.Item label="تنظیمات فوتر ">{business?.footerHtml}</Descriptions.Item>
                                        <Descriptions.Item label="بیمه های فعال">{business?.branches?.map((item, index) => item + (index < business?.branches?.length - 1 ? ' , ' : ''))}</Descriptions.Item>
                                    </Descriptions>
                                </TabPane>
                                <TabPane tab="دسکتاپ" id="desktop" key="2" >
                                    <Descriptions
                                        bordered
                                        size="small"
                                        column={1}>
                                        <Descriptions.Item className="business-info-tab" label="تعداد ستون‌های بولت‌ها در حالت دسکتاپ">
                                            {business?.IntroGridDesktop}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="نمایش عنوان اصلی ">
                                            {business?.titleInDesktop ?
                                                'دارد' :
                                                'ندارد'}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="نمایش هدر">
                                            {business?.headerInDesktop ?
                                                'دارد' :
                                                'ندارد'}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="نمایش فوتر">
                                            {business?.footerInDesktop ?
                                                'دارد' :
                                                'ندارد'}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="نمایش بج تخفیف و صدور آنلاین بر روی بولت‌های صفحه اول ">
                                            {business?.badgeInDesktop ?
                                                'دارد' :
                                                'ندارد'}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="نمایش مراحل خرید بیمه در صفحه اول">
                                            {business?.servicesInDesktop ?
                                                'دارد' :
                                                'ندارد'}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="نمایش بولت‌ها به شکل گرد (در این حالت نام رشته بیمه خارج از بولت نمایش داده میشود)">
                                            {business?.roundBulletInDesktop ?
                                                'دارد' :
                                                'ندارد'}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="عنوان رشته بیمه خارج از بولت">
                                            {business?.bulletTextOutInDesktop ?
                                                'دارد' :
                                                'ندارد'}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="نمایش بولت‌ها به شکل اوت‌لاین ">
                                            {business?.outlineBulletInDesktop ?
                                                'دارد' :
                                                'ندارد'}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="نمایش بنر آپلود شده">
                                            {business?.showDesktopBanner ?
                                                'دارد' :
                                                'ندارد'}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="زیر عنوان"> {business?.subTitleInDesktop}  </Descriptions.Item>
                                        <Descriptions.Item label="درباره ما">{business?.aboutInDesktop}</Descriptions.Item>
                                    </Descriptions>
                                </TabPane>
                                <TabPane tab="موبایل و تبلت" id="mobile" key="3" >
                                    <Descriptions
                                        bordered
                                        size="small"
                                        column={1}>
                                        <Descriptions.Item className="business-info-tab" label="تعداد ستون‌های بولت‌ها در حالت موبایل">
                                            {business?.IntroGridMobile}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="نمایش عنوان اصلی ">
                                            {business?.titleInMobile ?
                                                'دارد' :
                                                'ندارد'}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="نمایش هدر">
                                            {business?.headerInMobile ?
                                                'دارد' :
                                                'ندارد'}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="نمایش فوتر">
                                            {business?.footerInMobile ?
                                                'دارد' :
                                                'ندارد'}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="نمایش بج تخفیف و صدور آنلاین بر روی بولت‌های صفحه اول ">
                                            {business?.badgeInMobile ?
                                                'دارد' :
                                                'ندارد'}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="نمایش مراحل خرید بیمه در صفحه اول">
                                            {business?.servicesInMobile ?
                                                'دارد' :
                                                'ندارد'}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="نمایش بولت‌ها به شکل گرد در موبایل(در این حالت نام رشته بیمه خارج از بولت نمایش داده میشود)">
                                            {business?.roundBulletInMobile ?
                                                'دارد' :
                                                'ندارد'}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="عنوان رشته بیمه خارج از بولت در موبایل">
                                            {business?.bulletTextOutInMobile ?
                                                'دارد' :
                                                'ندارد'}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="نمایش بولت‌ها به شکل اوت‌لاین ">
                                            {business?.outlineBulletInMobile ?
                                                'دارد' :
                                                'ندارد'}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="نمایش بنر آپلود شده">
                                            {business?.showMobileBanner ?
                                                'دارد' :
                                                'ندارد'}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="زیر عنوان"> {business?.subTitleInMobile}  </Descriptions.Item>
                                        <Descriptions.Item label="درباره ما">{business?.aboutInMobile}</Descriptions.Item>
                                    </Descriptions>
                                </TabPane>
                                <TabPane tab="استایل ها" id="styles" key="4" >
                                    <Descriptions
                                        bordered
                                        size="small"
                                        column={1}>
                                        <Descriptions.Item className="business-info-tab" label="رنگ اصلی" >
                                            {business?.styles?.primaryColor}
                                            <div className='show-color-box' style={{ backgroundColor: business?.styles?.primaryColor }}></div>
                                        </Descriptions.Item>
                                        <Descriptions.Item className="business-info-tab" label="رنگ دوم" >
                                            {business?.styles?.secondaryColor}
                                            <div className='show-color-box' style={{ backgroundColor: business?.styles?.secondaryColor }}></div>
                                        </Descriptions.Item>
                                        <Descriptions.Item className="business-info-tab" label="رنگ پس‌زمینه" >
                                            {business?.styles?.backgroundColor}
                                            <div className='show-color-box' style={{ backgroundColor: business?.styles?.backgroundColor }}></div>
                                        </Descriptions.Item>
                                        <Descriptions.Item className="business-info-tab" label="رنگ پس زمینه آیکون رشته ها" >
                                            {business?.styles?.bulletsBackgroundColor}
                                            <div className='show-color-box' style={{ backgroundColor: business?.styles?.bulletsBackgroundColor }}></div>
                                        </Descriptions.Item>
                                        <Descriptions.Item className="business-info-tab" label="رنگ آیکون رشته ها" >
                                            {business?.styles?.bulletsSvgColor}
                                            <div className='show-color-box' style={{ backgroundColor: business?.styles?.bulletsSvgColor }}></div>
                                        </Descriptions.Item>
                                        <Descriptions.Item className="business-info-tab" label="رنگ عنوان رشته ها" >
                                            {business?.styles?.titleColor}
                                            <div className='show-color-box' style={{ backgroundColor: business?.styles?.titleColor }}></div>
                                        </Descriptions.Item>
                                        <Descriptions.Item className="business-info-tab" label="انحنای بوردر دکمه ها و اینپوت ها" >
                                            {business?.styles?.buttonsInputsRadius}
                                        </Descriptions.Item>
                                        <Descriptions.Item className="business-info-tab" label="رنگ متن آیتم های هدر" >
                                            {business?.styles?.headerTextColor}
                                            <div className='show-color-box' style={{ backgroundColor: business?.styles?.headerTextColor }}></div>
                                        </Descriptions.Item>
                                        <Descriptions.Item className="business-info-tab" label="رنگ متن آیتم های فوتر" >
                                            {business?.styles?.footerTextColor}
                                            <div className='show-color-box' style={{ backgroundColor: business?.styles?.footerTextColor }}></div>
                                        </Descriptions.Item>
                                        <Descriptions.Item className="business-info-tab" label="رنگ پس‌زمینه هدر و تولبار در سایز موبایل" >
                                            {business?.styles?.headerBackgroundColor}
                                            <div className='show-color-box' style={{ backgroundColor: business?.styles?.headerBackgroundColor }}></div>
                                        </Descriptions.Item>
                                        <Descriptions.Item className="business-info-tab" label="رنگ پس زمینه فوتر" >
                                            {business?.styles?.footerBackgroundColor}
                                            <div className='show-color-box' style={{ backgroundColor: business?.styles?.footerBackgroundColor }}></div>
                                        </Descriptions.Item>
                                        <Descriptions.Item className="business-info-tab" label="انحنای بوردر باکس ها" >
                                            {business?.styles?.cardsRadius}

                                        </Descriptions.Item>

                                    </Descriptions>
                                </TabPane>
                            </Tabs>
                        </div>
                    </Col>
                </Row>
            </Spin>
        </Modal>
    )
}